import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  mark: {
    width: 16,
    height: 16,
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: theme.palette.colors.lightTeal,
    margin: [0, theme.spacing(1)],
  },
  active: {
    backgroundColor: theme.palette.colors.teal,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/ProgressBar/useStyles.js